/**
 * Category slider – Swiper se slidesPerView: 'auto'.
 *
 * Šířky slidů určuje CSS (viz #category-swiper .swiper-slide), slider je
 * responzivní automaticky – zobrazí tolik auto-šířkových slidů, kolik se vejde,
 * zbytek "peekuje" za okraj (SCSS: overflow: visible). Swiper je globál
 * z vendor bundle (swiper-bundle.min.js).
 *
 * Přístupnost: klávesová navigace Swiperu je tady schválně vypnutá – šipky už
 * obsluhuje banner výš na stránce a oba slidery by na ně reagovaly naráz.
 * Místo toho slider dojede na kartu, na kterou uživatel dotabuje (WCAG 2.4.11
 * Focus Not Obscured – karta za okrajem by jinak zůstala mimo obrazovku).
 */
function initCategorySlider() {
    const el = document.getElementById('category-swiper');
    if (!el || typeof Swiper === 'undefined') return;

    const swiper = new Swiper(el, {
        slidesPerView: 'auto',
        spaceBetween: 16,
        grabCursor: true,
        mousewheel: {
            forceToAxis: true, // jen vodorovné gesto (2 prsty doleva/doprava na trackpadu)
        },
        pagination: {
            el: '.swiper-pagination-category',
            clickable: true,
        },
        a11y: {
            paginationBulletMessage: 'Přejít na skupinu karet {{index}}',
            slideLabelMessage: 'Karta {{index}} z {{slidesLength}}',
            slideRole: 'group',
            containerRoleDescriptionMessage: 'karusel',
            itemRoleDescriptionMessage: 'karta',
        },
        breakpoints: {
            820: { spaceBetween: 24 },
            1280: { spaceBetween: 30 },
        },
    });

    el.addEventListener('focusin', (event) => {
        const slide = event.target.closest('.swiper-slide');
        if (!slide) return;

        // karta, která je celá vidět, se nikam neposouvá – jinak by slider
        // poskakoval při každém tabu
        const view = el.getBoundingClientRect();
        const rect = slide.getBoundingClientRect();
        if (rect.left >= view.left - 1 && rect.right <= view.right + 1) return;

        const index = swiper.slides.indexOf(slide);
        if (index >= 0) swiper.slideTo(index);
    });
}

document.addEventListener('DOMContentLoaded', initCategorySlider);
